import { helpers } 		from './theme/helpers.js';
import { hamburger } 	from './theme/components/hamburger.js';

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
		lastScroll: 0,
	},
	init: function () {
		var self = this;

		// Global
		self.smoothScroll.init();
		self.onloadClass();

		// self.tableWrap();

		self.touch();

		// modal.init();
		hamburger.init();

	},
	onloadClass: function () {
		document.querySelector('body').classList.add('loaded');
	},
	tableWrap: function () {
		if( jQuery(".text-content table").length ) {
			jQuery( '.text-content table' ).wrap( '<div class="responsTable"></div>' )
		}
	},
	touch: function () {
		var self = this;

		var touchClass = self.globals.isTouch === true ? 'touch-device' : 'pointer-device';
		document.querySelector('body').classList.add( touchClass );
	},
	/* loadFancy: function() {
		// jQuery( 'p a[rel="noopener"]' ).has("img").fancybox(); class="fancybox" data-fancybox="gallery"
		jQuery( '.gallery-row a' ).each(function(){
			jQuery(this).attr( 'data-fancybox', 'gallery' );
		});
	}, */
	smoothScroll: {
		selector: 'a[href*="#"]:not([href="#"])',
		init: function () {
			var self = this;
			var scroll = new SmoothScroll(self.selector, {
				ignore: '[data-scroll-ignore]',
				topOnEmptyHash: false,
				speed: 1000,
				offset: 0,
				updateURL: false,
				easing: 'easeInOutCubic',
			});
		},
	},
	windowPosition: function () {
		return {
			x: window.pageXOffset || document.documentElement.scrollLeft,
			y: window.pageYOffset || document.documentElement.scrollTop,
		};
	},
	windowSizes: function () {
		return {
			width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
			height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
		};
	},
	onresize() {
		var self = this;
	},
	onscroll(position, previusPosition) {


	},
};

jQuery(document).ready(function ($) {
	theme.init();
});

window.addEventListener('scroll', function (e) {
	theme.onscroll();
});

window.addEventListener('resize', function (e) {
	theme.onresize();
});

window.onfocus = function () { 
	theme.globals.isTabActive = true; 
}; 

window.onblur = function () { 
	theme.globals.isTabActive = false; 
}; 

jQuery.fn.isOnScreen = function(){
    var win = jQuery(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};